import React from "react";
import {Container, Label, Row} from "reactstrap";
import "./viewField.sass";
import classNames from "classnames";

export interface IViewFieldProps {
  label?: string;
  helpText?: string;
  isRequired?: boolean;
  children?: React.ReactNode;
  value?: string;
}

const ViewField: React.FC<IViewFieldProps> = ({
  label,
  helpText,
  isRequired,
  children,
  value
}) => {
  return (
    <Container className="view-field" data-testid="viewField" fluid>
      {label && (
        <Row>
          <Label
            className={classNames("view-label", {
              "padding-bottom": !helpText
            })}
            for={label}
          >
            {label}
            {isRequired && "*"}
          </Label>
        </Row>
      )}
      {helpText && (
        <Row>
          <Label className="view-help-text">{helpText}</Label>
        </Row>
      )}
      <Row data-testid={`${label}-view`}>
        {children ?? <span>{value}</span>}
      </Row>
    </Container>
  );
};

export default ViewField;
